import { render } from "./SimpleValueList.vue?vue&type=template&id=fdb1728c"
import script from "./SimpleValueList.vue?vue&type=script&lang=js"
export * from "./SimpleValueList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__